export const environment = {
  production: true,
  apiUrl: 'https://icz-api-staging.smatsure.com',
  reinsuranceApiUrl: 'https://icz-api-staging.smatsure.com',
  tokenKey: '',
  userPermissionsKey: 'user_permissions',
  recaptcha: {
    clientKey: '6LfyOWwrAAAAAP7eP32i2qQcQ9aLdqM-aqimNPud',
    serverKey: '6LfyOWwrAAAAAFle6yd0MjIzHEbdYVk1Ei50S7os',
  },
  CI: true,
  idleTimeout: 10 * 60 * 1000,
  idleWarningTime: 2 * 60 * 1000,
};
